module.exports = __webpack_public_path__ + "static/img/Headicon.6f8d742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/Headicon.png
// module id = Seq3
// module chunks = 43